import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getThousandComma } from "../../../../Api/ApiCommon";
import { GetIsActivatedSubsId } from "../../../../Api/ServiceDatas";
import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import ReactApexChart from "react-apexcharts";
import {
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "../UserBoard/IndateSection";
import { DropDownLabel } from "./CreateSection";
import useIsMobile from "../../../../hooks/useIsMobile";
import { GetSubscriptionSetData } from "../../../../ApiTS/ServiceDatasTS";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";

interface ServiceSectionProps extends IndateSectionProps {}

export default function ServiceSection({ filter }: ServiceSectionProps) {
  const isMobile = useIsMobile();

  const [statusDropdownValue, setStatusDropdownValue] = useState<OptionType>({
    value: "0",
    label: "전체 (진행중 + 예정)",
  });

  const [series, setSeries] = useState<number[]>([]);
  const [subsName, setSubsName] = useState<string[]>([]);

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/percent?type=party&subtype=normal&date=${dayjs(filter.endDate)
            .add(1, "day")
            ?.format("YYYY-MM-DD")}`
        : undefined,
  });

  const optionList = [
    { label: "전체 (진행중 + 예정)", value: "0" },
    { label: "진행중", value: "normal" },
    { label: "예정", value: "schedule" },
  ];

  useEffect(() => {
    let data: { id: string; label: string; value: number }[] = [];
    let series: number[] = [];
    let subsList: string[] = [];

    if (response?.status === 200) {
      const sortedData = response?.data.sort((a: any, b: any) => {
        return Number(a.detail) - Number(b.detail);
      });

      for (let i = 0; i < sortedData.length; i++) {
        const element = sortedData[i];

        const dataPush = () => {
          data.push({
            id:
              getSubsNameBySubsId3(Number(element?.detail ?? 0)) ??
              element?.detail,
            label: element?.detail,
            value:
              statusDropdownValue?.value === "normal"
                ? Number(element?.data?.normal)
                : statusDropdownValue?.value === "schedule"
                ? Number(element?.data?.schedule)
                : Number(element?.data?.normal) +
                  Number(element?.data?.schedule),
          });

          series.push(
            statusDropdownValue?.value === "normal"
              ? Number(element?.data?.normal)
              : statusDropdownValue?.value === "schedule"
              ? Number(element?.data?.schedule)
              : Number(element?.data?.normal) + Number(element?.data?.schedule)
          );

          subsList.push(
            `${Number(element?.detail ?? 0)}_${getSubsNameBySubsId3(
              Number(element?.detail ?? 0)
            )}` ?? element?.detail
          );
        };

        if (Number(element?.detail)) {
          if (statusDropdownValue?.value === "0") {
            if (
              Number(element?.data?.normal) +
                Number(element?.data?.schedule) !==
              0
            ) {
              dataPush();
            }
          } else if (statusDropdownValue?.value === "normal") {
            if (Number(element?.data?.normal) !== 0) {
              dataPush();
            }
          } else if (statusDropdownValue?.value === "schedule") {
            if (Number(element?.data?.schedule)) {
              dataPush();
            }
          }
        }
      }

      setSeries(series);
      setSubsName(subsList);
    }
  }, [response, statusDropdownValue]);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>서비스별 생성 파티 현황</DashBoardSectionTitle>

        <DropDown
          isDisabled={false}
          initText="상태 선택"
          setDropDownValue={setStatusDropdownValue}
          optionList={optionList}
          dropdownValue={statusDropdownValue}
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DropDownLabel>{statusDropdownValue.label}</DropDownLabel>
        <DashBoardViewDate isMobile={isMobile}>
          {filter.endDate} 기준
        </DashBoardViewDate>

        <>
          <div style={{ width: "100%", height: 330 }}>
            <ReactApexChart
              type="pie"
              height={350}
              series={series}
              options={{
                chart: {
                  type: "pie",
                },
                labels: subsName,
                legend: {
                  position: "right",
                  offsetX: 20,
                  offsetY: 40,
                  markers: {
                    width: 10,
                    height: 10,
                    offsetX: -4,
                  },
                  fontFamily:
                    "-apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif",
                  fontSize: "13px",
                  fontWeight: 500,
                },
                plotOptions: {
                  pie: {
                    dataLabels: {
                      offset: -10,
                      minAngleToShowLabel: 15,
                    },
                  },
                },
                dataLabels: {
                  formatter: (val) => {
                    return `${Math.round(Number(val) * 10) / 10}%`;
                  },
                  dropShadow: {
                    blur: 2,
                  },
                  style: {
                    fontWeight: 500,
                  },
                },
                tooltip: {
                  y: {
                    formatter: (val) => `${getThousandComma(val)}개`,
                  },
                },
              }}
            />
          </div>
        </>
      </LineBox>
    </>
  );
}
